// import * as fromRoot from '@cigna/cigna-for-brokers/shared/data-access';
import * as fromRoot from '../../+state/app.model';
import isEmpty from 'lodash/isEmpty';

export function extractAdditionalDetails(metadata?: fromRoot.Metadata) {
  if (
    metadata &&
    metadata.outcome &&
    metadata.outcome.additionalDetails &&
    !isEmpty(metadata.outcome.additionalDetails)
  ) {
    const codeToExclude = ['500', '704001', '704002'];
    const code = metadata.outcome.additionalDetails.filter(
      (x) => codeToExclude.indexOf(x.code?.toString()) === -1,
    );
    return code.length ? code[0].code?.toString() : '0';
  }
  return '0';
}
